import axios from "axios"
export const authVeriry = (callback, errorcallback)=> {
    const token = localStorage.getItem('token')
    axios.get(`${process.env.REACT_APP_BACK_API}/profile/${token}`).then((res)=>{
        callback(res.data.user)
    }).catch((err)=>{
        errorcallback(err)
    })

} 